export const MEDIA_PLAYER_COLORS = {
  ACTIVE_STATUS_FILL: 'fill-accent-neutral-default',
  DEFAULT_STATUS_FILL: 'border-core-subtle',
  TIMELINE_TEXT_COLOR: 'text-core-default',
  ICON_COLOR: 'icon-core-default',
  TIMELINE_TEXT_COLOR_ALT: 'text-core-subtle'
};